export default "__VITE_ASSET__0007cb4a__"